import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button-next/new';
import Heading from '@atlaskit/heading';
import { Stack, Text, xcss } from '@atlaskit/primitives-next';
import Skeleton from '@atlaskit/skeleton';

import { messages } from './messages';

interface SummarySectionCardProps {
	title: string;
	value: number;
	isLoading: boolean;
	error: string | null;
	retry: () => void;
}

const containerStyle = xcss({
	borderRadius: 'border.radius.200',
	borderColor: 'color.border',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	padding: 'space.200',
	minHeight: '80px',
});

export const SummarySectionCard: React.FC<SummarySectionCardProps> = ({
	title,
	value,
	isLoading,
	error,
	retry,
}) => {
	if (isLoading) {
		return (
			<Stack xcss={containerStyle} grow="fill" alignBlock="center" space="space.075">
				<Skeleton height="12px" width="100%" />
				<Skeleton height="20px" width="100%" />
			</Stack>
		);
	}

	if (error) {
		return (
			<Stack
				xcss={containerStyle}
				grow="fill"
				alignBlock="center"
				alignInline="center"
				space="space.025"
			>
				<Heading size="small" as="h3">
					<FormattedMessage {...messages.errorHeading} />
				</Heading>
				<Button appearance="subtle" onClick={retry} spacing="compact">
					<Text size="small" color="color.link">
						<FormattedMessage {...messages.refresh} />
					</Text>
				</Button>
			</Stack>
		);
	}

	return (
		<Stack xcss={containerStyle} grow="fill" alignBlock="center" space="space.075">
			<Heading size="xxsmall" as="h3">
				{title}
			</Heading>
			<Heading size="medium">{value}</Heading>
		</Stack>
	);
};
